// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2nOyB","description":"PatientConsentPreview_description__ATC8J"};